import LineBreak from "components/LineBreak/LineBreak";
import { AddContactSVG, GreenTickSVG, RedCrossSVG } from "components/SVG/SVG";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { toastError } from "hooks/useToastify";
import React, { ChangeEvent, useState } from "react";
import { updateUserEmail } from "store/async-actions/Profile/profileAction";
import { profileRespSelector } from "store/reducers/Profile/profile";

const ProfileEmail = () => {
  const profile = useAppSelector(profileRespSelector);

  const [enterEmail, setEnterEmail] = useState(false);

  const handleAddEmail = () => {
    setEnterEmail(true);
  };

  const handleCloseEmail = () => {
    setEnterEmail(false);
  };

  const [email, setEmail] = useState("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const dispatch = useAppDispatch();

  const handleSaveEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      dispatch(
        updateUserEmail({
          email: email,
        })
      );
      handleCloseEmail();
      setEmail("");
    } else {
      toastError("Please enter a valid email");
    }
  };

  return (
    <div>
      {!!profile?.email ? (
        <p>{profile?.email}</p>
      ) : (
        <div>
          {enterEmail ? (
            <div className="link_edit_save_wrapper social_link_edit_input_wrapper_underline">
              <input
                className="social_link_edit_input"
                placeholder="Enter Email"
                name="email"
                value={email}
                onChange={handleChange}
              />
              <div className="sle_confirm_btns">
                <div onClick={handleSaveEmail} className="pointer">
                  <GreenTickSVG />
                </div>
                <div onClick={handleCloseEmail} className="pointer">
                  <RedCrossSVG />
                </div>
              </div>
            </div>
          ) : (
            <>
              <LineBreak />
              <div onClick={handleAddEmail} className="contact_empty_add">
                <AddContactSVG />
                <p>Add Email</p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfileEmail;
